<template>
    <v-dialog :value="dialog" @input="$emit('input',$event)" flat class="dt-border" max-width="600">
        <template v-slot:activator="{ on, attrs }">
            
            <v-btn @click="doSomething" depressed :color="color" dark v-bind="attrs" v-on="on">
                <slot name="button"></slot>
            </v-btn>
        </template>
        <template>
            <slot name="content"></slot>
        </template>
    </v-dialog>
</template>

<script>
export default {
    data:() =>({

    }),
    props:{
        dialog:{
            type:Boolean,
        },
        color:{
            type:String,
            default : '#F36F2E'
        }
    },
    methods:{
        doSomething(){
            this.$emit('openModal')
        },
    },
    watch:{
        dialog(){
            if( this.dialog == false ){
                this.$emit('closeModal')
            }
        }
    }
}
</script>